module.exports = __webpack_public_path__ + "img/lead-modal.5f8e767b.jpg";